import { NgModule } from '@angular/core';
import { AllRetailersComponent } from './all-retailers/all-retailers.component';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { AgGridModule } from 'ag-grid-angular';
import { RetailerRoutingModule } from './retailer-routing.module';
import { RetailerComponent } from './retailer.component';
import { NewRetailerComponent } from './new-retailer/new-retailer.component';
import { ManageRetailerComponent } from './manage-retailer/manage-retailer.component';
import { NewRetailerSmartComponent } from './new-retailer/new-retailer-smart.component';
import {EditRetailerSmartComponent} from './manage-retailer/edit-retailer/edit-retailer-smart.component';
import {EditRetailerComponent} from './manage-retailer/edit-retailer/edit-retailer.component'
import { RetailerService } from './retailer.service';
import { ViewPaymentHistoryComponent } from './manage-retailer/view-payment-history/view-payment-history.component';
import { TransactionsModule } from './manage-retailer/transactions/transactions.module';
import { CloseRetailersComponent } from './close-retailers/close-retailers.component';
import { DeleteRetailerComponent } from './close-retailers/delete-retailer/delete-retailer.component';
import { AuthorizationService } from 'src/app/features-common/services/authorization.service';
import { LinkedRetailerComponent } from './manage-retailer/edit-retailer/linked-retailer/linked-retailer.component';
import { CommentsComponent } from './manage-retailer/comments/comments.component';
import { CreatecommentsComponent } from './manage-retailer/comments/createcomments/createcomments.component';
import { EditcommentComponent } from './manage-retailer/comments/editcomment/editcomment.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { RetailerTiersComponent } from './retailer-tiers/retailer-tiers.component';
import { ManageTiersComponent } from './retailer-tiers/manage-tiers/manage-tiers.component';
import { AllTiersComponent } from './retailer-tiers/all-tiers/all-tiers.component';
import { CustomTooltip } from 'src/app/features-common/components/tool-tip/tool-tip.component';
import { RetailerRequestsComponent } from './retailer-requests/retailer-requests.component';

@NgModule({
  declarations: [AllRetailersComponent, NewRetailerComponent, NewRetailerSmartComponent, ManageRetailerComponent,RetailerComponent,
    EditRetailerSmartComponent,EditRetailerComponent, ViewPaymentHistoryComponent, CloseRetailersComponent, DeleteRetailerComponent, LinkedRetailerComponent, CommentsComponent, CreatecommentsComponent, EditcommentComponent, RetailerTiersComponent, ManageTiersComponent, AllTiersComponent, RetailerRequestsComponent, ],
  imports: [
    FeaturesCommonModule,
    RetailerRoutingModule,
    AgGridModule.withComponents([CustomTooltip]),
    TransactionsModule,
    NgxMaterialTimepickerModule
    
  ],
  exports: [AllRetailersComponent, ManageRetailerComponent, NewRetailerSmartComponent,EditRetailerSmartComponent,RetailerComponent,TransactionsModule
  ],
  providers: [
    RetailerService, 
    AuthorizationService,
  ]
})
export class RetailerModule { }
